import AsyncComponent from '../../component/asynccomponent/AsyncComponent';
import { RolesEnum, CompanyTypesEnum } from '../../utils/Enums';

const invoice = AsyncComponent(() =>
  import('../../../pages/invoice/Invoice')
)

const invoices = AsyncComponent(() =>
  import('../../../pages/invoice/Invoices')
)

export default [
  {
    path: '/invoice',
    component: invoice,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Hired]
  },
  {
    path: '/invoice/:id',
    component: invoice,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Hired, CompanyTypesEnum.Contractor]
  },
  {
    path: '/invoices',
    component: invoices,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Hired, CompanyTypesEnum.Contractor]
  }
]


// WEBPACK FOOTER //
// ./src/shared/infra/routes/InvoiceRoutes.js